export function Form(props: {
  children: React.ReactNode;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
}): React.ReactElement {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit && props.onSubmit(event);
      }}
    >
      {props.children}
    </form>
  );
}
